import { SVGProps, Ref, forwardRef } from 'react';

export const ShareWebFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m18.645 6.819-3.406-2.105c-2.37-1.465-3.554-2.197-4.396-1.364-.707.7-.821 2.153-.84 4.852C2.517 9.952.535 15.78.014 18.97c-.137.838.82 1.316 1.523.84 1.835-1.246 4.966-2.983 8.476-3.27.037 2.23.191 3.478.83 4.11.843.833 2.028.1 4.397-1.364l3.406-2.105C22.215 14.974 24 13.871 24 12s-1.785-2.974-5.355-5.181"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ShareWebFilledSize24Glyph.displayName = 'ShareWebFilledSize24Glyph';
